import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { View, useStyleSheet, createStyleSheet, IconButton, Text, Divider } from '@gopeerproject/ui-kit';
import { useModalContext } from '../../hooks';
import { uuid } from '@gopeerproject/chuck';
export const PortalModal = ({ children, onClose, title }) => {
    const modalId = useRef(uuid());
    const node = document.getElementById('modal');
    const ref = useRef(null);
    const styles = useStyleSheet(getStyles);
    const { activeModals, registerModal, unregisterModal } = useModalContext();
    useEffect(() => {
        registerModal(modalId.current);
        const id = modalId.current;
        return () => {
            unregisterModal(id);
        };
    }, [registerModal, unregisterModal]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            const current = ref.current;
            if (activeModals.current[activeModals.current.length - 1] ===
                modalId.current &&
                current &&
                !current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClose]);
    useEffect(() => {
        const onEsc = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', onEsc);
        return () => {
            document.removeEventListener('keydown', onEsc);
        };
    }, [onClose]);
    if (!node)
        return null;
    return ReactDOM.createPortal(React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.wrapper, ref: ref },
            !!title && (React.createElement(React.Fragment, null,
                React.createElement(View, { style: styles.header },
                    React.createElement(Text, { type: 'heading', size: 'h6' }, title),
                    React.createElement(IconButton, { value: 'dismiss', type: 'tertiary', accent: 'neutral', onPress: onClose, style: styles.dismiss, size: 'sm' })),
                React.createElement(Divider, { type: 'horizontal', style: styles.divider }))),
            children)), node);
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flex: 1,
        left: 0,
        right: 0,
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color.black.p26
    },
    header: {
        paddingVertical: size.G,
        paddingLeft: size.K,
        paddingRight: size.G,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    dismiss: {
        marginLeft: size.K
    },
    divider: {
        marginHorizontal: size.K
    },
    wrapper: {
        backgroundColor: color.bg.v2,
        borderRadius: size.G
    }
}));
//# sourceMappingURL=index.js.map